import type { JSX } from 'react';

export function ActionError({ message }: { message: string | null }): JSX.Element | null {
  return message ? (
    <p role="alert" className="text-sm text-red-700">
      {message}
    </p>
  ) : null;
}
